import LoginForm from '../components/loginForm/LoginForm';

export default function LoginPage() {
  return (<LoginForm />);
}
